<div class="d-flex flex-row align-items-center portal__login-page">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <portal-card>
          <ng-container header>
            {{ 'resetPassword' | translate }}
          </ng-container>

          <ng-container actions>
            <a
              [portalTippy]="'resetPassword.back.to.login.page' | translate"
              appendTo="body"
              routerLink="/login"
            >
              <i class="far fa-fw fa-sign-in me-1"></i>
            </a>
          </ng-container>

          <portal-stepper [controls]="false" [linear]="true" [selectedIndex]="selectedIndex">
            <!-- Username -->
            <cdk-step [editable]="true" state="username">
              <form
                class="bootstrap-validation-background--hidden"
                [formGroup]="usernameForm"
                (ngSubmit)="submitUsername()"
              >
                <portal-error-alert [dismissible]="false" [error]="error">
                  <ng-template portalTransclude="title">Fehler</ng-template>
                </portal-error-alert>

                <div class="form-group">
                  <label class="form-label" for="loginName">
                    {{ 'resetPassword.loginName' | translate }}

                    <i
                      class="far fa-fw fa-question-circle tooltip-help"
                      [portalTippy]="'login.username.info' | translate"
                    ></i>
                  </label>

                  <input
                    class="form-control"
                    id="loginName"
                    [portalAutofocus]="true"
                    [skipValidationIfPristine]="true"
                    autocomplete="off"
                    formControlName="loginName"
                    portalInputValidityState
                    type="text"
                  />

                  <portal-form-validation-errors
                    [skipValidationIfPristine]="true"
                    controlName="loginName"
                  ></portal-form-validation-errors>
                </div>

                <div class="text-end">
                  <!-- <div class="d-flex justify-content-between">
                  <button
                    class="btn btn-link p-0"
                    [disabled]="usernameForm.invalid"
                    (click)="goToEnterAuthCode()"
                    >
                    {{ 'resetPassword.toEnterAuthCodeStep' | translate }}
                  </button> -->

                  <portal-save-button
                    [disabledOnPristine]="true"
                    [invalid]="usernameForm.invalid"
                    [noTooltips]="true"
                    [pristine]="usernameForm.pristine"
                    [state]="loading"
                  >
                    {{ 'button.go.forward' | portalTranslate }}
                  </portal-save-button>
                </div>
              </form>
            </cdk-step>
            <cdk-step [editable]="false" state="token">
              <form
                class="bootstrap-validation-background--hidden"
                [formGroup]="tokenForm"
                (ngSubmit)="submitToken()"
              >
                <portal-error-alert [dismissible]="false" [error]="error"></portal-error-alert>

                <div class="form-group">
                  <label class="form-label" for="token">
                    {{ 'resetPassword.authCode' | translate }}
                  </label>

                  <input
                    class="form-control"
                    id="token"
                    [portalAutofocus]="true"
                    [skipValidationIfPristine]="true"
                    autocomplete="off"
                    formControlName="token"
                    portalInputValidityState
                    type="text"
                  />

                  <portal-form-validation-errors
                    [skipValidationIfPristine]="true"
                    controlName="token"
                  ></portal-form-validation-errors>
                </div>

                <div class="d-flex justify-content-between">
                  <button class="btn btn-outline-secondary" (click)="goBack()" type="button">
                    {{ 'button.go.back' | translate }}
                  </button>

                  <portal-save-button
                    [disabledOnPristine]="true"
                    [invalid]="tokenForm.invalid"
                    [noTooltips]="true"
                    [pristine]="tokenForm.pristine"
                    [state]="loading"
                  >
                    {{ 'button.go.forward' | portalTranslate }}
                  </portal-save-button>
                </div>
              </form>
            </cdk-step>
            <cdk-step [editable]="false" state="password">
              <form
                class="bootstrap-validation-background--hidden"
                [formGroup]="newPasswordForm"
                (ngSubmit)="submitPassword()"
              >
                <portal-error-alert [dismissible]="false" [error]="error"></portal-error-alert>

                @if (stepper?.selected.state === 'password') {
                  <portal-password-strength formControlName="newPassword"></portal-password-strength>
                }

                <div class="text-end">
                  <portal-save-button
                    [disabledOnPristine]="true"
                    [invalid]="newPasswordForm.invalid"
                    [noTooltips]="true"
                    [pristine]="newPasswordForm.pristine"
                    [state]="loading"
                  >
                    {{ 'button.go.forward' | portalTranslate }}
                  </portal-save-button>
                </div>
              </form>
            </cdk-step>
            <cdk-step [editable]="false">
              <p>
                {{ 'resetPassword.success' | translate }}
              </p>

              <div class="text-end">
                <a class="btn btn-primary" routerLink="/login">
                  {{ 'resetPassword.back.to.login.page' | translate }}
                </a>
              </div>
            </cdk-step>
          </portal-stepper>
        </portal-card>
      </div>
    </div>
  </div>
</div>
